import { types } from 'mobx-state-tree';

type Fn = () => void;

export const functionType = types.custom<Fn, Fn>({
  name: 'functionType',
  fromSnapshot(value: Fn) {
    return value;
  },
  toSnapshot(value: Fn) {
    return value;
  },
  getValidationMessage(value: Fn) {
    if (typeof value !== 'function') {
      return `value "${value}" is Not a valid function`;
    }

    return '';
  },
  isTargetType(value) {
    return value instanceof Function;
  },
});

export default functionType;
